import { useFocusEffect } from 'expo-router';
import React from 'react';
import { RefreshControl, ScrollView, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { useDashboardMetrics } from '@/api/partners/dashboard/use-dashboard-metrics';
import DashboardMetricsSection from '@/components/dashboard/metrics-section';
import { Loader } from '@/ui/loader';

export default function DashboardMetrics() {
  const { styles, theme } = useStyles(stylesheet);
  const {
    data: dashboardMetricsData,
    isLoading: isLoadingDashboardMetrics,
    refetch: refetchDashboardMetrics,
  } = useDashboardMetrics({});

  useFocusEffect(
    React.useCallback(() => {
      refetchDashboardMetrics();
    }, [refetchDashboardMetrics])
  );

  if (isLoadingDashboardMetrics) {
    return (
      <View
        style={{
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme.colors.background_1,
        }}
      >
        <Loader style={{ height: 250, width: 250 }} />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={styles.scrollContentContainer}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl
            refreshing={isLoadingDashboardMetrics}
            onRefresh={async () => {
              await refetchDashboardMetrics();
            }}
          />
        }
      >
        <DashboardMetricsSection metrics={dashboardMetricsData} />
      </ScrollView>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background_1,
  },
  scrollContentContainer: {
    flexGrow: 1,
    paddingTop: 24,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 24,
  },
}));
